<template>
  <div>
    <v-layout row wrap>
      <v-flex class="tituloBox p-b-30 border-top">
        <div class="bg-primary barraTitulo"></div>
        <v-btn icon @click="openBox()" right absolute>
          <v-icon>unfold_more</v-icon>
        </v-btn>
        <h1 class="text-info font-size-18">
          <strong>Família</strong>
        </h1>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-show="showBox">
      <v-flex row wrap>
        <v-card>
          <v-data-table
            :headers="localcabecalhoFamilia"
            :items="model.familiaSolicitacao"
            :hide-actions="true"
           
          >
            <template slot="items" slot-scope="props">
              <td>{{props.item.familiaAssociada.codFamilia}} - {{props.item.familiaAssociada.descFamilia}}</td>
              <td >{{props.item.familiaAssociada.descGrupo}}</td>
              <td >{{props.item.familiaAssociada.tipoItem}}</td>
              <td >
                <span
                  v-show="Number(props.item.codGrupo)>9"
                >{{retornaEnumDescricao("tipoQualificacao",props.item.tipoQualificacao)}}</span>
              </td>
              <td v-if="$verificaPerfilCadastrador() || $verificaPerfilHabilitador()" class="text-xs-center naoImprimir">
                <a v-if="exibeDocumentoAnexoFamilia(props.item.anexoFamilia)" v-bind:href="props.item.anexoFamilia.arquivoUpload" target="_blank">
                  <v-icon color="blue">attach_file</v-icon>
                </a>
                <v-icon v-else color="grey">attach_file</v-icon> 
              </td>                 
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import util from "../../../plugins/util";
export default {
  name: "extrato-familia",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    dominio: Object,
    enums: Object
  },
  created() /*Metodo de start do componente*/{},
  data() {//Declaracao de variaveis
    return {
      showBox: true,
      localcabecalhoFamilia: [],
    };
  },
  mounted() {
    this.localcabecalhoFamilia = this.cabecalhoFamilia; // Inicializa com os headers do mixin
    if (this.$verificaPerfilCadastrador() || this.$verificaPerfilHabilitador()) {
      this.localcabecalhoFamilia.push({
        text: this.$t("label.anexo"),
        align: "center",
        sortable: false,
        class: "naoImprimir",
      });
    }
  },
  methods: {//Declaracao de todos os metodos
    openBox() {
      //abrir o box com o detalhamento
      this.showBox = !this.showBox;
    },

    retornaEnumDescricao(_enum, valor) {
      //retorna a descricao do enum
      if (!valor || !this.enums[_enum]) return "";
      let retorno = this.enums[_enum].find(x => x.valor === valor);
      return retorno ? retorno.descricao : null;
    },

    exibeDocumentoAnexoFamilia(anexoFamilia){
      if(anexoFamilia != undefined){
        return anexoFamilia.numDocumentoSEI != undefined;
      }else{
        return false;
      }
    }
  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.infoDados .v-card {
  padding: 15px;
}

.infoDados .linhaInfo {
  display: block;
  padding: 5px 0;
}

.theme--light.v-table thead {
  background: none;
}
</style>


